<div class="layout-wrapper" [ngClass]="containerClass">
    <app-topbar></app-topbar>
    <div class="layout-sidebar" *ngIf="!router.url.includes('company-detail') || isFrozenColumn" >
        <app-sidebar></app-sidebar>
<!--        <img src="../../../../assets/images/geminiLogo.png" class="grmini-logo" style="width: 100px;-->
<!--        height: 40px; position: absolute; bottom: 40px; left: 30px;">-->
    </div>
    <div class="layout-main-container " [ngClass]="{'company-detail-route': isCompanyDetailRoute}">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <div class="layout-mask"></div>
</div>

<style>

   
        ::ng-deep .company-detail-route {
              margin-left: 0px !important;
              padding: 0rem !important;
             
            }
       
    </style>